import { render, staticRenderFns } from "./doclistedit.vue?vue&type=template&id=8c982cc6"
import script from "./doclistedit.vue?vue&type=script&lang=js"
export * from "./doclistedit.vue?vue&type=script&lang=js"
import style0 from "./doclistedit.vue?vue&type=style&index=0&id=8c982cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports